import mainComponent from '@/layouts/main/Main.vue'

export default [{
  path: '/necessidadeDePecas',
  component: mainComponent,
  title: 'Necessidade de Peças',
  children: [{
      path: '/',
      name: 'partsRequirement-list',
      component: () => import('@/views/partsRequirement/PartsRequirementList.vue'),
      meta: {
        requiresAuth: true,
        breadcrumb: [
          { title: 'Home', url: '/' },
          { title: 'Comercial' },
          { title: 'Necessidade de Peças', active: true },
        ],
        pageTitle: 'Necessidade de Peças',
        rule: 'editor'
      },
    },
    {
      path: 'visualizar/:idPartsRequirement',
      name: 'partsRequirement-view',
      component: () => import('@/views/partsRequirement/ViewPartsRequirement.vue'),
      meta: {
        requiresAuth: true,
        breadcrumb: [
          { title: 'Home', url: '/' },
          { title: 'Comercial' },
          { title: 'Necessidade de Peças', url: '/necessidadeDePecas' },
          { title: 'Visualizar', active: true },
        ],
        pageTitle: 'Necessidade de Peças',
        rule: 'editor'
      },
    },
  ],
}, ];